export default {
    methods: {
        origin(path = "") {
            if (this.$i18n.locale == 'en') {
                return 'https://outracoisa.co/en' + path
            } else {
                return 'https://outracoisa.co' + path
            }
        }
    }
}